<!-- 报表/用户统计(运营) -->
<template>
  <div class="content">
    <el-tabs v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="按创建时间统计" name="1"> </el-tab-pane>
      <el-tab-pane label="按付款时间统计" name="2"> </el-tab-pane>
    </el-tabs>
    <!-- 用户统计（运营）列表的2个tab页顶部统计暂时隐藏（等财务审计完后再进行显示） -->
    <div class="info-list" v-show="userList.length<0">
      <span>累计注册：{{userData.registerTotal}}</span>
      <span>活跃店铺：{{userData.bindStoreTotal}}</span>
      <span>shopify店铺累计：{{userData.shopifyBindStoreTotal}}</span>
      <span>shoplazza店铺累计：{{userData.shoplazzaBindStoreTotal}}</span>
      <span>shopline店铺累计：{{userData.shoplineBindStoreTotal}}</span>
      <span>woocommerce店铺累计：{{userData.woocommerceBindStoreTotal}}</span>
      <span>commentSold店铺累计：{{userData.commentSoldBindStoreTotal}}</span>
      <span>tiktok店铺累计：{{userData.tiktokBindStoreTotal}}</span>
      <span>temu店铺累计：{{userData.temuBindStoreTotal}}</span>
      <p>
        <span>累计总订单数：{{userData.orderTotal}}</span>
        <span>累计订单总金额：${{userData.orderAmountTotal}}</span>
        <span>已付款订单总金额: ${{userData.orderPaymentAmountTotal}}</span>
      </p>
    </div>
    <div class="filter">
      <el-date-picker v-model="registerDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="handleDatePick"></el-date-picker>
      <span class="update-time">更新时间：{{userData.modifyDate}}</span>
      <el-button @click="exportUserTotal">数据导出</el-button>
      <!-- <el-button @click="exportOrderDetail">订单明细导出</el-button> -->
      <el-button @click="showDialog">列表字段配置</el-button>
    </div>

    <!-- <div style="height:calc(100vh - 278px)"> -->
      <!-- <el-table :data="userList" @sort-change="sortTotalTable" max-height="calc(100vh - 278px)"> -->
      <el-table v-if="dataLoaded" :data="userList" @sort-change="sortTotalTable" :max-height="maxHeight">
      <!-- 固定显示部分 -->
      <el-table-column sortable="custom" label="日期" min-width="130" prop="period">
        <template slot-scope="{row,$index}">
          <span>{{$index===0?"总计":sliceString(row.period) }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="activeUserDaily" label="访客数（UV）" min-width="150"></el-table-column>
      <!-- 暂时隐藏 -->
      <!-- <el-table-column sortable="custom" prop="registerDaily" label="新增注册" min-width="120"></el-table-column> -->
      <el-table-column v-for="(item,index) in columns" :key="index" sortable="custom" :prop="item.value" :label="item.title" min-width="200">
        <template slot-scope="{row}">
          <span> <span v-show="item.title.indexOf('金额')>-1">$</span> {{row[item.value]}}</span>
        </template>
      </el-table-column>

    </el-table>
    <!-- </div> -->

    <div class="f-b-c bg-white" style="padding: 10px">
      <div></div>
      <el-pagination background :current-page="userTotalForm.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="userTotalForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleTotalSizeChange" @current-change="pageChange" />
    </div>
    <el-dialog title="列表字段配置" :visible.sync="visible" width="800px" @close="close" :close-on-click-modal="false">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
        <el-checkbox style="width:20%;margin-bottom:10px" v-for="(item,index) in columnTitles" :key="index" :label="item.value">{{item.title}}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import { dateFormat } from '@/utils/date'
export default {
  name: 'report_userStatistcBy',
  data() {
    return {
      tabName: '1',
      total: 0,
      visible: false,
      registerDate: [Date.now() - 29 * 24 * 3600000, Date.now()],
      configId: undefined,
      selected: [], // 所有已选项
      userList: [], // 用户列表
      userTotalForm: {
        pageNumber: 1,
        pageSize: 20,
      },
      roleForm: {
        roleList: [10]
      },
      isIndeterminate: true,
      checkAll: false,
      show: false,
      userManager: [],//对接人列表
      userData: {},
      exportForm: {},
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setHours(0, 0, 0, 0), start.setHours(23, 59, 59, 999));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date().setHours(23, 59, 59, 999) - 24 * 3600000;
            const start = new Date().setHours(0, 0, 0, 0) - 24 * 3600000;
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近七天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近15天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上个月',
          onClick(picker) {
            const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).getTime();
            const end = new Date(new Date().getFullYear(), new Date().getMonth(), 0).getTime() + 24 * 3600000 - 60;
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          return time.getTime() > new Date().setHours(23, 59, 59, 999);
        },
      },
      columns: [
        { title: '累计注册', value: 'registerIncrTotal', check: true, },
        { title: '新增绑定店铺数', value: 'bindStoreDaily', check: true },
        { title: '累计绑定店铺数', value: 'bindStoreIncrTotal', check: true },
        { title: '上架产品店铺数 ', value: 'publishStoreDaily', check: true },
        { title: '上架产品数 ', value: 'publishListingDaily', check: true },
        { title: '出单店铺数', value: 'orderStoreDaily', check: true },
        { title: '下单总数', value: 'orderDaily', check: true },
      ],
      checkList: [],
      columnTitles: [
        { title: '累计注册', value: 'registerIncrTotal', check: true },
        { title: '新增绑定店铺数', value: 'bindStoreDaily', check: true },
        { title: '累计绑定店铺数', value: 'bindStoreIncrTotal', check: true },
        { title: '上架产品店铺数 ', value: 'publishStoreDaily', check: true },
        { title: '上架产品数 ', value: 'publishListingDaily', check: true },
        { title: '出单店铺数', value: 'orderStoreDaily', check: true },
        { title: '下单总数', value: 'orderDaily', check: true },
        { title: '下单总金额', value: 'orderAmountDaily', check: false },
        { title: '已付款订单总数', value: 'orderPaymentNumDaily', check: false },
        { title: '已付款订单总金额', value: 'orderPaymentAmountDaily', check: false },
        { title: 'kaka付款订单数', value: 'orderKkPaymentNumDaily', check: false },
        { title: 'kaka付款总金额', value: 'orderKkPaymentAmountDaily', check: false },
        { title: 'shopify付款订单数', value: 'orderSpPaymentNumDaily', check: false },
        { title: 'shopify付款总金额', value: 'orderSpPaymentAmountDaily', check: false },
        { title: 'shoplazza付款订单数', value: 'orderDjPaymentNumDaily', check: false },
        { title: 'shoplazza付款总金额', value: 'orderDjPaymentAmountDaily', check: false },
        { title: 'shopline付款订单数', value: 'orderSlPaymentNumDaily', check: false },
        { title: 'shopline付款总金额', value: 'orderSlPaymentAmountDaily', check: false },
        { title: 'woocommerce付款订单数', value: 'orderWcPaymentNumDaily', check: false },
        { title: 'woocommerce付款总金额', value: 'orderWcPaymentAmountDaily', check: false },
        { title: 'commentSold付款订单数', value: 'orderCsPaymentNumDaily', check: false },
        { title: 'commentSold付款总金额', value: 'orderCsPaymentAmountDaily', check: false },
        { title: 'tiktok付款订单数', value: 'orderTtPaymentNumDaily', check: false },
        { title: 'tiktok付款总金额', value: 'orderTtPaymentAmountDaily', check: false },
        { title: 'temu付款订单数', value: 'orderPdPaymentNumDaily', check: false },
        { title: 'temu付款总金额', value: 'orderPdPaymentAmountDaily', check: false },
        { title: '退款订单数', value: 'orderReturnNumDaily', check: false },
        { title: '退款总金额', value: 'orderReturnAmountDaily', check: false },
        { title: '停用店铺数', value: 'deactivateStoreDaily', check: false },
      ],
      backUpColumn: [],
      rowHeight: 47, // 每行的高度
      maxRows: 17,    // 显示的最大行数
      dataLoaded: false // 数据加载状态
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.$message.error('当前日期不可选')
      }
    }
  },
  computed: {
    getSortType() {
      return (type) => {
        switch (type) {
          case 'ascending':
            return 1
          case 'descending':
            return 2
          case null:
            return 1
        }
      }
    },
    getUserTotalSortName() {
      return (name) => {
        switch (name) {
          case 'period':
            return 1
          case 'activeUserDaily':
            return 2
          case 'registerDaily':
            return 3
          case 'bindStoreDaily':
            return 4
          case 'publishStoreDaily':
            return 5
          case 'publishListingDaily':
            return 6
          case 'orderStoreDaily':
            return 7
          case 'orderDaily':
            return 8
          case 'orderAmountDaily':
            return 9
          case 'orderPaymentAmountDaily':
            return 10
          case 'deactivateStoreDaily':
            return 11
          case 'orderKkPaymentAmountDaily':
            return 12
          case 'orderSpPaymentAmountDaily':
            return 13
          case 'orderDjPaymentAmountDaily':
            return 14
          case 'orderSlPaymentAmountDaily':
            return 15
          case 'orderWcPaymentAmountDaily':
            return 16
          case 'orderCsPaymentAmountDaily':
            return 17
          case 'orderTtPaymentAmountDaily':
            return 18
          case 'orderPdPaymentAmountDaily':
            return 19
          case 'registerIncrTotal':
            return 20
          case 'bindStoreIncrTotal':
            return 21
          case 'orderPaymentNumDaily':  
            return 22
          case 'orderKkPaymentNumDaily':
            return 23
          case 'orderSpPaymentNumDaily':
            return 24
          case 'orderDjPaymentNumDaily':
            return 25
          case 'orderSlPaymentNumDaily':
            return 26
          case 'orderWcPaymentNumDaily':
            return 27
          case 'orderCsPaymentNumDaily':
            return 28
          case 'orderTtPaymentNumDaily':
            return 29
          case 'orderPdPaymentNumDaily':
            return 30
          case 'orderReturnAmountDaily':
            return 31
          case 'orderReturnNumDaily':
            return 32
          case null:
            return undefined
        }
      }
    },
    maxHeight() {
      return this.rowHeight * this.maxRows;
    }
  },
  created() {
    this.getUserTotalReportManage()
    this.getUserInfoSelect()
    this.getBehaviorConfig()
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkList = val ? this.columnTitles.map(item => item.value) : []
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.columnTitles.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnTitles.length;
    },
    handleClick() {
      if (this.tabName === '1') {
        this.getUserTotalReportManage()
      } else {
        this.getUserTotalReportPaymentTime()
      }
    },

    showDialog() {
      this.visible = true,
        this.checkList = this.columns.map(item => item.value)
      this.backUpColumn = _.cloneDeep(this.checkList)
    },

    close() {
      this.checkList = _.cloneDeep(this.backUpColumn)
      this.visible = false
      let checkedCount = this.checkList.length;
      this.checkAll = checkedCount === this.columnTitles.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnTitles.length;
    },

    save() {
      this.columns = _.cloneDeep(this.columnTitles).filter(item => this.checkList.includes(item.value))
      // 获取选中的值
      this.selected = _.cloneDeep(this.columns).map(item => item.title)
      this.setBehaviorConfig()
      this.userTotalForm.showFields = [...this.checkList, 'period', 'activeUserDaily', 'registerDaily']
      if (this.tabName === '1') {
        this.getUserTotalReportManage()
      } else {
        this.getUserTotalReportPaymentTime()
      }
      this.backUpColumn = this.checkList
      this.visible = false
      this.$forceUpdate()
    },
    getBehaviorConfig() {
      // 获取用户概览的列表字段显示
      API.getBehaviorConfig(5).then((res) => {
        if (!res.data) return
        this.checkList = res.data.content
        this.columns = _.cloneDeep(this.columnTitles).filter(item => this.checkList.includes(item.title))
        this.configId = res.data.id
      })
    },
    setBehaviorConfig() {
      const params = {
          type: 5,
          content: JSON.stringify(this.selected),
          id: this.configId
      }
      API.setBehaviorConfig(params)
    },

    //数据导出
    importExportFile() {
      API.importExportFile(this.exportForm).then(() => {
        this.$message.success('数据导出成功,请前往导入导出中心查看进度')
      })
    },

    sliceString(str) {
      str = str.toString()
      return str.slice(0, 4) + '-' + str.slice(4, 6) + '-' + str.slice(6)

    },

    //用户概况导出
    exportUserTotal() {
      let showFields = this.columns.map(item => item.value)
      showFields = _.uniq([...showFields, 'period', 'activeUserDaily', 'registerDaily'])
      let form = {
        periodEnd: this.userTotalForm.periodEnd,
        periodStart: this.userTotalForm.periodStart,
        showFields: showFields
      }
      if (this.tabName === '1') {
        this.exportForm = {
          fileType: 2,
          taskType: 12,
          condition: JSON.stringify(form)
        }
      } else {
        this.exportForm = {
          fileType: 2,
          taskType: 11,
          condition: JSON.stringify(form)
        }
      }
      this.importExportFile()
    },
    exportOrderDetail() {
      let form = {
        periodEnd: this.sliceString(this.userTotalForm.periodEnd),
        periodStart: this.sliceString(this.userTotalForm.periodStart)
      }
      this.exportForm = {
        fileType: 2,
        taskType: 8,
        condition: JSON.stringify(form)
      }
      this.importExportFile()
    },

    //获取用户概况
    getUserTotalReportManage() {
      this.userTotalForm.periodStart = dateFormat(this.registerDate[0], 'yyyy-MM-dd').replace(/-/g, '') || dateFormat(Date.now() - 30 * 24 * 3600000, 'yyyy-MM-dd').replace(/-/g, '')
      this.userTotalForm.periodEnd = dateFormat(this.registerDate[1], 'yyyy-MM-dd').replace(/-/g, '') || dateFormat(Date.now() - 1, 'yyyy-MM-dd').replace(/-/g, '')
      API.getUserTotalReportManage(this.userTotalForm).then(res => {
        this.setData(res);
      })
    },
    getUserTotalReportPaymentTime() {
      this.userTotalForm.periodStart = dateFormat(this.registerDate[0], 'yyyy-MM-dd').replace(/-/g, '') || dateFormat(Date.now() - 30 * 24 * 3600000, 'yyyy-MM-dd').replace(/-/g, '')
      this.userTotalForm.periodEnd = dateFormat(this.registerDate[1], 'yyyy-MM-dd').replace(/-/g, '') || dateFormat(Date.now() - 1, 'yyyy-MM-dd').replace(/-/g, '')
      API.getUserTotalReportPaymentTime(this.userTotalForm).then(res => {
        this.setData(res);
      })
    },

    setData(res) {
      this.userList = _.get(res, 'data.vo.list', [])
      this.dataLoaded = true
      this.userData =  _.get(res, 'data.vo', {})
      this.total = res.data.total
      if(res.data.vo){
        this.userData.modifyDate = dateFormat(res.data.vo.modifyDate)
      }
      this.$tableScrollTop()
    },
    timeFormat(time) {
      return dateFormat(time)
    },

    //对接人列表
    getUserInfoSelect() {
      API.getUserInfoSelect(this.roleForm).then(res => {
        this.userManager = res.data
      })
    },

    //时间筛选用户概览
    handleDatePick(value) {
      if (value && value.length === 2) {
        this.userTotalForm.periodStart = dateFormat(value[0], 'yyyy-MM-dd').replace(/-/g, '')
        this.userTotalForm.periodEnd = dateFormat(value[1], 'yyyy-MM-dd').replace(/-/g, '')
        this.resetPage()
      } else {
        this.$nextTick(() => {
          this.registerDate = [Date.now() - 29 * 24 * 3600000, Date.now()]
          this.$forceUpdate()
          this.resetPage()
        })
      }
    },
    resetPage() {
      this.userTotalForm.pageNumber = 1
      if (this.tabName === '1') {
        this.getUserTotalReportManage()
      } else {
        this.getUserTotalReportPaymentTime()
      }
    },
    //用户概览分页
    pageChange(page) {
      this.userTotalForm.pageNumber = page
      if (this.tabName === '1') {
        this.getUserTotalReportManage()
      } else {
        this.getUserTotalReportPaymentTime()
      }
    },

    handleTotalSizeChange(size) {
      this.userTotalForm.pageSize = size
      if (this.tabName === '1') {
        this.getUserTotalReportManage()
      } else {
        this.getUserTotalReportPaymentTime()
      }
    },


    //用户概览排序
    sortTotalTable({ prop, order }) {
      this.userTotalForm.sortType = this.getSortType(order)
      this.userTotalForm.sortName = this.getUserTotalSortName(prop)
      this.resetPage()
    },


  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: #ffffff;
  padding: 12px 12px 0;
  .filter {
    padding: 12px;
    & > div {
      margin-left: 12px;
    }
    /deep/.el-input-group {
      width: 300px;
    }
    /deep/.el-input-group__prepend {
      width: 100px;
    }
  }
}
.range-num {
  display: inline-block;
  margin-right: 16px;
}
.update-time {
  display: inline-block;
  margin: 0 16px;
}

.avatar {
  width: 178px;
  height: 178px;
  object-fit: cover;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
/deep/.el-range-separator {
  min-width: 20px;
}
.info-list {
  height: 30px;
  padding-left: 22px;
  color: #99c41c;
  font-size: 16px;
  span {
    display: inline-block;
    margin-right: 16px;
  }
}
</style>>
